import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient , HTTP_INTERCEPTORS} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterializeModule } from 'angular2-materialize';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

/* Components */
import { HomeComponent } from './_components/components_welcome/home/home.component';
import { FooterComponent } from './_components/components_includes/footer/footer.component';
import { HeaderComponent } from './_components/components_includes/header/header.component';
import { SpinnerComponent } from './_components/components_includes/spinner/spinner.component';
import { UserVerificationComponent } from './_components/user-verification/user-verification.component';
import { SendemailComponent } from './_components/forgetPassword/sendemail/sendemail.component';
import { ResetpasswordComponent } from './_components/forgetPassword/resetpassword/resetpassword.component';
import { UserComponent } from './_components/user/user.component';
import { LoginComponent } from './_components/login/login.component';
import { SignupComponent } from './_components/signup/signup.component';

/* Services */
import { ApiRequestService } from './_services/api-request.service';
import { AuthenticationService } from './_services/authentication.service';
import { CookieService, CookieOptions } from 'angular2-cookie/core';
import { AuthService } from './_services/auth.service';
import { AuthGuard } from './_guards/auth.guard';
import { VerificationGuard } from './_guards/verification.guard';
import { TokenInterceptorService } from './_services/token-interceptor.service';
import { Ng2PageScrollModule } from 'ng2-page-scroll';
import { NgxInactivity } from 'ngx-inactivity';
import { DataTableModule } from 'angular-4-data-table/src/index';


import { CombineComponent } from './_components/components_welcome/combine/combine.component';
import { GatewayComponent } from './_components/components_user/gateway/gateway.component';
import { MedicolegalComponent } from './_components/components_user/medicolegal/medicolegal.component';
import { ApicallComponent } from './_components/components_user/apicall/apicall.component';
import { WorkscomComponent } from './_components/components_user/workscom/workscom.component';
import { CasesimilarityComponent } from './_components/components_user/casesimilarity/casesimilarity.component';
import { ElasticsearchformComponent } from './_components/components_user/elasticsearchform/elasticsearchform.component';
import { ResultsComponent } from './_components/components_user/results/results.component';
import { ProfileComponent } from './_components/components_user/profile/profile.component';
import { QueryResultComponent } from './_components/components_user/query-result/query-result.component';
import { QueryAnalysisComponent } from './_components/components_user/query-analysis/query-analysis.component';
import { DashboardComponent } from './_components/components_user/dashboard/dashboard.component';
import { AngularMultiSelectModule } from 'angular4-multiselect-dropdown/angular4-multiselect-dropdown';
import { SubscribeResultComponent } from './_components/components_user/subscribe-result/subscribe-result.component';
import { SubscribeAnalysisComponent } from './_components/components_user/subscribe-analysis/subscribe-analysis.component';
import { PaginationComponent } from './_components/components_user/pagination/pagination.component';
import { StatenameComponent } from './_components/components_user/statename/statename.component';
import { DriverComponent } from './_components/components_user/driver/driver.component';
import { PreAuthorizationComponent } from './_components/components_user/pre-authorization/pre-authorization.component';
import { CompensationClaimComponent } from './_components/components_user/compensation-claim/compensation-claim.component';
import { DeniedCompensationComponent } from './_components/components_user/denied-compensation/denied-compensation.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    SpinnerComponent,
    UserComponent,
    LoginComponent,
    SignupComponent,
    UserVerificationComponent,
    SendemailComponent,
    ResetpasswordComponent,
    CombineComponent,
    GatewayComponent,
    MedicolegalComponent,
    ApicallComponent,
    WorkscomComponent,
    CasesimilarityComponent,
    ElasticsearchformComponent,
    ResultsComponent,
    ProfileComponent,
    QueryResultComponent,
    QueryAnalysisComponent,
    DashboardComponent,
    SubscribeResultComponent,
    SubscribeAnalysisComponent,
    PaginationComponent,
    StatenameComponent,
    DriverComponent,
    PreAuthorizationComponent,
    CompensationClaimComponent,
    DeniedCompensationComponent
  ],
  imports: [
    BrowserModule,
    Ng2PageScrollModule,
    MaterializeModule,
    FormsModule,
    AngularMultiSelectModule,
    HttpClientModule,
    HttpModule,
    NgxInactivity,
    DataTableModule,
    ReactiveFormsModule,
    AppRoutingModule
  ],
  providers: [
    AuthenticationService,
    CookieService,
    AuthService,
    AuthGuard,
    VerificationGuard,
    ApiRequestService,
    { provide: CookieOptions, useValue: {} },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/app.module.ts